import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ItemManagement18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M12.5304 8.03033L11.4697 6.96967L8.00006 10.4393L6.53039 8.96967L5.46973 10.0303L8.00006 12.5607L12.5304 8.03033Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.5 1.25H5.275C5.39082 0.67944 5.89526 0.25 6.5 0.25H11.5C12.1047 0.25 12.6092 0.67944 12.725 1.25H15.5C16.2141 1.25 16.75 1.88679 16.75 2.57692V16.4231C16.75 17.1132 16.2141 17.75 15.5 17.75H2.5C1.7859 17.75 1.25 17.1132 1.25 16.4231V2.57692C1.25 1.88679 1.7859 1.25 2.5 1.25ZM6.75 1.75V3.25H11.25V1.75H6.75ZM12.75 3.5V2.75H15.25V16.25H2.75V2.75H5.25V3.5C5.25 4.19036 5.80964 4.75 6.5 4.75H11.5C12.1904 4.75 12.75 4.19036 12.75 3.5Z'
      fill='currentColor'
    />
  </Svg>
);

ItemManagement18.displayName = 'ItemManagement18';
export default ItemManagement18;
